exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".enabled_96be9b8{background-color:#52c41a}.disabled_2ed7d9a,.enabled_96be9b8{display:inline-block;width:5px;height:5px;border-radius:50%;vertical-align:middle;margin-right:5px}.disabled_2ed7d9a{background-color:#ff4d4f}", ""]);

// exports
exports.locals = {
	"enabled": "enabled_96be9b8",
	"disabled": "disabled_2ed7d9a"
};